$(function () {
    const CLOSED_COUNT_KEY = 'vk_ads_birthday_banner_closed_count';
    const CLICKED_KEY = 'vk_ads_birthday_banner_clicked';
    const SHOWN_COUNT_KEY = 'vk_ads_birthday_banner_shown_count';
    const MAX_CLOSES = 1;
    const MAX_SHOWS = 5;
    const BANNER_SELECTOR = '[data-target="vk-ads-birthday-banner"]';
    const CLOSE_SELECTOR = '[data-target="vk-ads-birthday-banner-close"]';
    const PROMO_URL = 'https://ads.vk.com/promo/welcome?ref=Senler';

    const initBanner = () => {
        const banner = $(BANNER_SELECTOR);

        if (!banner.length) {
            return;
        }

        try {
            if (localStorage.getItem(CLICKED_KEY) === '1') {
                banner.hide();
                return;
            }

            const closedCount = parseInt(localStorage.getItem(CLOSED_COUNT_KEY) || '0', 10);

            if (closedCount >= MAX_CLOSES) {
                banner.hide();
                return;
            }

            const shownCount = parseInt(localStorage.getItem(SHOWN_COUNT_KEY) || '0', 10);

            if (shownCount >= MAX_SHOWS) {
                banner.hide();
                return;
            }

            localStorage.setItem(SHOWN_COUNT_KEY, (shownCount + 1).toString());
        } catch (error) {
            // Если localStorage недоступен, показываем баннер
        }

        setTimeout(() => {
            banner.addClass('vk-ads-birthday-banner--visible');
        }, 100);

        const onBannerClick = (e) => {
            if ($(e.target).closest(CLOSE_SELECTOR).length) {
                return;
            }

            try {
                localStorage.setItem(CLICKED_KEY, '1');
            } catch (error) {}

            window.carrotquest && window.carrotquest.track('Клик по баннеру VK Реклама (ДР)');
            window.open(PROMO_URL, '_blank');
            banner.hide();
        };

        banner.on('click', onBannerClick);
        banner.on('keydown', (e) => {
            // С крестика keydown всплывает — не перехватываем Space/Enter
            if ($(e.target).closest(CLOSE_SELECTOR).length) {
                return;
            }

            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onBannerClick(e);
            }
        });

        const closeButton = banner.find(CLOSE_SELECTOR);
        if (closeButton.length) {
            closeButton.on('click', (e) => {
                e.stopPropagation();
                window.carrotquest && window.carrotquest.track('Закрыл баннер VK Реклама (ДР)');
                closeBanner(banner);
            });
        }
    };

    const closeBanner = (banner) => {
        banner.removeClass('vk-ads-birthday-banner--visible');
        banner.addClass('vk-ads-birthday-banner--closing');

        setTimeout(() => {
            banner.hide();

            try {
                const closedCount = parseInt(localStorage.getItem(CLOSED_COUNT_KEY) || '0', 10);
                localStorage.setItem(CLOSED_COUNT_KEY, (closedCount + 1).toString());
            } catch (error) {}
        }, 300);
    };

    initBanner();
});
